import { useTranslation } from 'react-i18next';
import { ArrowUpRight } from 'lucide-react';

export const PARTNER_URL =
  'https://qualwheycomprar.com.br/?utm_source=meutreino&utm_medium=banner&utm_campaign=parceria&utm_content=dashboard';

// The partner's wordmark, recreated as type (their logo file can replace it if they send one)
export const Wordmark = () => (
  <span className="mt-partner__mark">
    Qual <span className="mt-partner__mark-whey">Whey</span> Comprar<span className="mt-partner__mark-q">?</span>
  </span>
);

// Partner block on the dashboard (Qual Whey Comprar?): a compact card in our style. Brazilian partner: the pt site
// only, never the en one.
export const PartnerBanner = ({ onOpen }) => {
  const { t } = useTranslation();

  if (t('lang') !== 'pt') return null;

  return (
    <aside className="mt-partner mt-partner--card" aria-label={t('components.PartnerBanner.label')}>
      <a className="mt-partner__card" href={PARTNER_URL} target="_blank" rel="noopener sponsored" onClick={onOpen}>
        <span className="mt-partner__head">
          <Wordmark />
          <span className="mt-partner__pill">{t('components.PartnerBanner.partner')}</span>
        </span>
        <span className="mt-partner__text">{t('components.PartnerBanner.pitch')}</span>
        <span className="mt-partner__cta">
          {t('components.PartnerBanner.cta')}
          <ArrowUpRight aria-hidden="true" />
        </span>
        <span className="mt-sr-only"> {t('components.PartnerBanner.newTab')}</span>
      </a>
    </aside>
  );
};
